import { Component, OnInit, inject, model, signal } from '@angular/core';
import { TableModule } from 'primeng/table';
import { StatsComponent } from './stats/stats.component';
import { Stats } from './models/stats';
import { User } from '../shared/models/user.model';
import { ProfileService } from '../profile/services/profile.service';
import { AdvertisingListComponent } from '../advertising/advertising-list/advertising-list.component';
import { CardModule } from 'primeng/card';
import { UserListComponent } from '../user/user-list/user-list.component';
import { DashboardService } from './services/dashboard.service';
import { ContractListComponent } from '../contract/contract-list/contract-list.component';
import { Role } from '../shared/enum/role.enum';
import { ButtonGroupModule } from 'primeng/buttongroup';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { PermissionsListComponent } from '../permissions/permissions-list/permissions-list.component';
import { RolesListComponent } from '../roles/roles-list/roles-list.component';
import { AccessService } from '../core/services/access.service';
import { ImagesListComponent } from '../images/images-list/images-list.component';
import { BranchesListComponent } from '../branches/branches-list/branches-list.component';
import { SkeletonModule } from 'primeng/skeleton';
import { TurnPerDayComponent } from '../turn/turn-per-day/turn-per-day.component';
import { ServiciosListComponent } from '../servicios/servicios-list/servicios-list.component';
import { TurnStatistucsListComponent } from '../turn/turn-statistucs-list/turn-statistucs-list.component';
import { TurnStatistucsGrafhicComponent } from '../turn/turn-statistucs-grafhic/turn-statistucs-grafhic.component';
import { ContractModel } from '../shared/models/contract.model';
import { BranchModel } from '../shared/models/branch.model';
import { Servicio } from '../servicios/models/servicio.model';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    TableModule,
    StatsComponent,
    AdvertisingListComponent,
    CardModule,
    UserListComponent,
    ContractListComponent,
    ButtonGroupModule,
    ButtonModule,
    RippleModule,
    PermissionsListComponent,
    RolesListComponent,
    ImagesListComponent,
    BranchesListComponent,
    SkeletonModule,
    // TurnPerDayComponent,
    ServiciosListComponent,
    TurnStatistucsListComponent,
    TurnStatistucsGrafhicComponent,
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css',
})
export class DashboardComponent implements OnInit {
  protected access = inject(AccessService).access;
  protected service = inject(DashboardService);
  constructor(
    // public dashboardService: DashboardService,
    private profileService: ProfileService
  ) {}

  profile = signal<User | undefined>(undefined);

  roleEnum = Role;

  stats!: Stats[];

  filtersGraft?: {
    contract: ContractModel | undefined;
    branch: BranchModel | undefined;
    servicio: Servicio | undefined;
  };

  rangeDates = model<Date[] | undefined>(undefined);

  userLengthModel = model<Stats>();
  contractLengthModel = model<Stats>();
  imageLengthModel = model<Stats>();
  permissionLengthModel = model<Stats>();
  advertisingLengthModel = model<Stats>();
  roleLengthModel = model<Stats>();
  branchLengthModel = model<Stats>();
  servicioLengthModel = model<Stats>();

  ngOnInit(): void {
    this.profile = this.profileService.getProfile();
    this.stats = [
      {
        content: {
          title: 'Orders',
          value: '152',
          button: {
            icon: 'pi pi-shopping-cart',
            color: 'bg-blue-100 text-blue-500',
          },
        },
        // value: '24 new',
        // comment:'since last visit',
      },
      {
        content: {
          title: 'Orders',
          value: '152',
          button: {
            icon: 'pi pi-shopping-cart',
            color: 'bg-blue-100 text-blue-500',
          },
        },
        // value: '24 new',
        // comment:'since last visit',
      },
    ];
  }

  onFilter(event: {
    contract: ContractModel | undefined;
    branch: BranchModel | undefined;
    servicio: Servicio | undefined;
  }) {
    this.filtersGraft = event;
  }

  userLength(length: number) {
    this.userLengthModel.update((value) => {
      return this.service.getUserLength(length);
    });
  }
  contractLength(length: number) {
    // console.log('Cantidad de Usarios: ', length)
    this.contractLengthModel.update((value) => {
      return this.service.getContractLength(length);
    });
  }
  imageLength(length: number) {
    this.imageLengthModel.update((value) => {
      return this.service.getImageLength(length);
    });
  }
  permissionLength(length: number) {
    this.permissionLengthModel.update((value) => {
      return this.service.getPermissionLength(length);
    });
  }
  advertisingLength(length: number) {
    this.advertisingLengthModel.update((value) => {
      value = this.service.getAdvertisingLength(length);
      // console.log('cantida de anuncios',value)
      return value;
    });
  }
  branchLength(length: number) {
    this.branchLengthModel.update((value) => {
      return this.service.getBranchLength(length);
    });
  }
  serviciosLength(length: number) {
    this.servicioLengthModel.update((value) => {
      return this.service.getServicioLength(length);
    });
  }
  onRangeDates(rangeDate: Date[]) {
    // console.log('Range Dates: ', rangeDate)
    this.rangeDates.update((value) => {
      value = rangeDate;
      return value;
    });
  }
}
